import React, { useState, useEffect } from "react";
import SidePannel from "./component/Menu/SidePannel";
import Header from "./component/Menu/header";
import ThemeProvider from "./ThemeProvider";
import useStyles from "./styles";
import LayoutData from "./data";
import axios from "axios";
import { decryptData, encryptData } from "./crypto";
import HomePageRoutes from "./Routes";
import { useLocation } from "react-router-dom";
import SidePannelData from "./component/Menu/sidePannelData";
import KycPopup from "./component/Pages/PopupScreen/PlanPopup";
import { useProfile } from "./context/ProfileContext";
import ContextProvider from "./context/ContextProvider";
import SessionExpiredPopup from "./SessionExpiredPopup";
import { updateBranding } from "./Utils/brandingUtils";

function App() {
  const classes = useStyles();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [menuCollapse, setMenuCollapse] = useState(false);
  const [parsedUserData, setParsedUserData] = useState("");
  const [header, setHeader] = useState(SidePannelData);
  const { fetchProfileData, profile } = useProfile();

  const location = useLocation();
  const [formId, setFormId] = useState("");
  const [formFound, setFormFound] = useState(false);

  useEffect(() => {
    // Dynamic title & logo/apple-touch-icon update based on URL
    updateBranding(location.pathname);

    // Parse formId from the URL
    const pathArray = location.pathname.split("/");
    const id = pathArray[pathArray.length - 1];
    setFormId(id);
  }, [location]);

  const decryptedToken = decryptData(sessionStorage.getItem("token"));

  const decryptedUserName = JSON.stringify(
    decryptData(sessionStorage.getItem("userName"))
  );

  useEffect(() => {
    if (decryptedUserName) {
      setParsedUserData(decryptedUserName.trim().replace(/"/g, ""));
    }
  }, []);

  const [globalProfileImageState, setGlobalProfileImageState] = useState({
    image: "",
    name: "",
  });

  const dynamicPath = window.location.pathname.substring(1);
  const layoutData = LayoutData.find((item) => item.name === dynamicPath);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const userName = sessionStorage.getItem("userName");
    if (token && userName) {
      setIsLoggedIn(true);
    }
    // if (token) {
    //   const decryptedToken = decryptData(token);
    //   if (decryptedToken) {
    //     fetchDataFromAPI(decryptedToken);
    //   } else {
    //     sessionStorage.clear();
    //     setIsLoggedIn(false);
    //   }
    // } else {
    //   setIsLoggedIn(false);
    // }
  }, []);

  const handleLogin = () => {
    const token = sessionStorage.getItem("token");
    const userName = sessionStorage.getItem("userName");
    if (token && userName) {
      setIsLoggedIn(true);
    }
    // if (token) {
    //   const decryptedToken = decryptData(token);
    //   if (decryptedToken) {
    //     fetchDataFromAPI(decryptedToken);
    //   } else {
    //     sessionStorage.clear();
    //     setIsLoggedIn(false);
    //   }
    // } else {
    //   setIsLoggedIn(false);
    // }
  };

  const handleMenuCollapse = () => {
    setMenuCollapse(!menuCollapse);
  };

  // const fetchFormData = async () => {
  //   try {
  //     const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/forms/${formId}`;
  //     const response = await axios.get(apiUrl);

  //     if (response.status === 200) {
  //       const data = response.data?.form;
  //       setFormFound(data.uid === formId);
  //     } else {
  //       console.log("data not found");
  //       setFormFound(false);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching Form data API:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchFormData();
  // }, [formId]);

  const fetchDataFromAPI = async (decryptedToken) => {
    try {
      if (!decryptedToken) {
        console.error("Token is null");
        // sessionStorage.clear();
        // setIsLoggedIn(false);
        return;
      }

      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/auth/profile`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });

      if (response && response.status === 200) {
        setGlobalProfileImageState((prev) => ({
          ...prev,
          name: response?.data?.user?.full_name,
        }));
        setGlobalProfileImageState((prev) => ({
          ...prev,
          image: response?.data?.user?.image_url,
        }));
        if (response?.data?.user?.id) {
          sessionStorage.setItem("userId", encryptData(response.data.user.id));
        }
        // setIsLoggedIn(true);
        return response;
      } else {
        // sessionStorage.clear();
        // setIsLoggedIn(false);
      }
    } catch (error) {
      console.error("Error fetching data from the API:", error);
      // sessionStorage.clear();
      // setIsLoggedIn(false);
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        sessionStorage.clear();
        setIsLoggedIn(false);
      }
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      const decryptedToken = decryptData(token);
      fetchDataFromAPI(decryptedToken);
    } else {
      console.error("Token is null");
    }
  }, [isLoggedIn]);

  const dashboardItem = header.find((item) => item.name === "Dashboard");
  return (
    // <React.StrictMode>
    <ThemeProvider>
      {({ darkMode, toggleDarkMode }) => (
        <>
          <div className={`${classes.dflex} ${classes.w100}`}>
            {isLoggedIn && (
              <div className={`${menuCollapse ? classes.w5 : classes.w18}`}>
                <SidePannel
                  menuCollapse={menuCollapse}
                  globalProfileImageState={globalProfileImageState}
                  /* fetchMainMenuDataFromAPI={fetchMainMenuDataFromAPI}*/
                  header={header}
                />
              </div>
            )}

            <div
              className={
                layoutData
                  ? `${classes.w100}`
                  : `${menuCollapse ? classes.w100 : classes.w85} ${classes.h100vh
                  } ${formFound && classes.m0auto}`
              }
            >
              {isLoggedIn && (
                <div className={classes.header}>
                  <Header
                    handleMenuCollapse={handleMenuCollapse}
                    menuCollapse={menuCollapse}
                    darkMode={darkMode}
                    toggleDarkMode={toggleDarkMode}
                  />
                </div>
              )}
              <HomePageRoutes
                isLoggedIn={isLoggedIn}
                fetchDataFromAPI={fetchDataFromAPI}
                globalProfileImageState={globalProfileImageState}
                // fetchDataFromAPI={fetchProfileData}
                layoutData={layoutData}
                handleLogin={handleLogin}
                formFound={formFound}
                header={header}
              />
            </div>
          </div>
          <SessionExpiredPopup />
        </>
      )}
    </ThemeProvider>
    // </React.StrictMode>
  );
}
export default App;
